import { useState, useEffect } from "react";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";

import CartDetails from "../CartDetails";
import Button from "../Button";
import { BounceLoader } from "react-spinners";
import { dataLayerPush } from "../../helpers/analytics";
import useCalculators from "../../helpers/useCalculators";
import ScheduleNavigation from "../ScheduleNavigation";

const OrderComplete = (props) => {
  const {actions, state, sendState} = useStateMachineWrapper();
  const {getSubtotal} = useCalculators();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);

    let saleType = state.session.isPreorder ? 'Pre_sale' : 'Active_sale';
    dataLayerPush({
      'event' : saleType,
      'order-number' : window.sessionStorage.getItem('orderID') ?? '',
      'order-total' : getSubtotal()
    });
  }, []);

  if(isLoading) {
    return (
      <BounceLoader color={'#8200A8'} speedMultiplier={.75} className="self-center" />
    );
  }

  if(!state.session.currentAddress) {
    return (<>
      <em>Your session has expired.</em>
      <Button className="mt-4" size="large" color="purple" onClick={() => actions.update({page: 'intro'})}>Get Started</Button>
    </>)
  }

  const orderId = window.sessionStorage.getItem('orderID') ?? '';

  var _holiday_promo_text = "";
  if(sessionStorage.getItem('holiday_promo')){
   // console.log('Promo found in summary');
    _holiday_promo_text = "You will receive an email from  i3broadband@mybundle.com within 24 hours after your service has been installed with details on how to redeem your Streaming Gift Card.";
  }else {
    //console.log('Promo not found in summary');
  }

  return (<>
        {/* <Breadcrumbs /> */}

        <h1 className="bigger">Thank you for {state.session.isPreorder ? 'reserving' : 'ordering'} your i3 Broadband services!</h1>
        {!state.session.isPreorder && <ScheduleNavigation/>}
        {state.session.isPreorder && <p>We'll reach out to schedule your free professional installation as soon as services become available in your area.</p>}
        <p>Please review the details of your {state.session.isPreorder ? 'reservation' : 'order'}</p>

        <div className="border-2 rounded-lg w-full max-w-xl mx-auto mt-4 p-4">
          <p className="text-center text-blue font-bold">Order Number: {orderId}</p>

          <div className="text-left border-b-2 pb-4">
            <p className="font-bold">Account Information:</p>
            <p><b>Email:</b> {state.session.email}</p>
            <p><b>Cell Phone:</b> {state.session.phoneNumber}</p>
            <p><b>Service Address:</b> {state.session.currentAddress?.full_address}</p>
          </div>

          <CartDetails/>
        </div>


        {/* mx-auto inline-block */}
        <div className="px-6 py-4">
          <h1 className="bigger">What Happens Next?</h1>
          <p>
            <b>Please check your email for your {state.session.isPreorder ? 'reservation' : 'order'} information.</b>
            <br/>
            A copy of your {state.session.isPreorder ? 'request' : 'order'} along with additional details has been sent to your email.
          </p><br/>
          <p className="holiday-promo-text">{_holiday_promo_text}</p>
          <h1 className="big !mt-4">Thanks again for choosing i3!  We'll be seeing you soon</h1>
        </div>
        <div className="px-6 py-4">
          <p>By providing your cell phone number, you agree to receive texts from i3 Broadband, LLC about fiber-based service availability, support and /or billing -related information. It will not be used to market new services to you without your consent. Standard Data rates may apply. You may opt out at any time by replying "STOP" to any text message.</p>
        </div>
    </>)

};

export default OrderComplete;
